<template>
  <div style="display: flex">
    <svg xmlns="http://www.w3.org/2000/svg"
         fill="none"
         :width="size"
         :height="size"
         viewBox="0 0 20 20"
         :aria-labelledby="iconName"
         @mouseover="isHover = true;"
         @mouseout="isHover = false;"
    >
      <g :fill="isHover ? iconHoverColor : iconColor">
        <slot />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "IconBase",
  data() {
    return {
      isHover: false
    }
  },
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    size: {
      type: [Number, String],
      default: 20
    },
    iconColor: {
      type: String,
      default: '#9A9A9A'
    },
    iconHoverColor: {
      type: String,
      default: '#9A9A9A'
    },
  }
}
</script>

<style scoped>

</style>